import { Link } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { Avatar, AvatarFallback } from '../ui/avatar'

import { ThemeToggle } from '../ui/theme-toggle'
import { Button } from '../ui/button'
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuTrigger, 
  DropdownMenuItem,
  DropdownMenuSeparator 
} from '../ui/dropdown-menu'
import Notification from '../common/Notification'

type HeaderProps = {
	onMenuClick: () => void
	isAdmin?: boolean
}

const Header = ({ onMenuClick, isAdmin = false }: HeaderProps) => {
	const { user, logout } = useAuth()

	const handleLogout = async () => {
		try {
			await logout()
		} catch (error) {
			console.error('Logout error:', error)
		}
	}

	return (
		<header className="sticky top-0 z-30 border-b bg-card shadow-sm">
			<div className="flex h-16 items-center justify-between px-4">
				<div className="flex items-center">
					<Button
						variant="ghost"
						size="icon"
						onClick={onMenuClick}
						className="mr-2 md:hidden"
						aria-label="Open sidebar"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						>
							<line x1="3" y1="12" x2="21" y2="12" />
							<line x1="3" y1="6" x2="21" y2="6" />
							<line x1="3" y1="18" x2="21" y2="18" />
						</svg>
					</Button>
					<h1 className="text-3xl font-bold text-primary">
						{isAdmin ? 'Ubuntu Cab' : 'Ubuntu Cab'}
					</h1>
				</div>

				<div className="flex items-center space-x-4">
					<ThemeToggle />
					<Notification />
					<DropdownMenu>
						<DropdownMenuTrigger asChild>
							<Button variant="ghost" className="h-8 w-8 rounded-full">
								<Avatar className="h-8 w-8">
									<AvatarFallback className="bg-primary text-primary-foreground">
										{user?.username?.charAt(0) || user?.email?.charAt(0) || 'U'}
									</AvatarFallback>
								</Avatar>
							</Button>
						</DropdownMenuTrigger>
						<DropdownMenuContent className="w-56" align="end" forceMount>
							<div className="flex items-center justify-start gap-2 p-2">
								<div className="flex flex-col space-y-1 leading-none">
									{user?.username && (
										<p className="font-medium">{user.username}</p>
									)}
									{user?.email && (
										<p className="w-[200px] truncate text-sm text-muted-foreground">
											{user.email}
										</p>
									)}
								</div>
							</div>
							<DropdownMenuSeparator />
							<DropdownMenuItem asChild>
								<Link to={isAdmin ? '/admin/profile' : '/profile'}>
									Profile
								</Link>
							</DropdownMenuItem>
							<DropdownMenuItem asChild>
								<Link to={isAdmin ? '/admin/settings' : '/settings'}>
									Settings
								</Link>
							</DropdownMenuItem>
							<DropdownMenuSeparator />
							<DropdownMenuItem onClick={handleLogout}>
								Logout
							</DropdownMenuItem>
						</DropdownMenuContent>
					</DropdownMenu>
				</div>
			</div>
		</header>
	)
}

export default Header
